import { RxCross2 } from "react-icons/rx";
import { useState, useEffect } from "react";
import axios from "axios";
import { useStateContext } from "../../../Context/ContextProvider";
import { toast } from "react-toastify";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';


export default function ModalUpdateObjectif({ showModalUpdateObjectif, closeModalObjectif, idModule, idObjectif, onObjectifUpdated }) {

    const { token } = useStateContext();

    const [loading, setLoading] = useState(false);
    const [objectifInput, setObjectifInput] = useState("");

    useEffect(() => {
        if (!idModule || !idObjectif) return;

        axios.get(`https://catalogue.mg.formafusion.io/api/cfp/modules/${idModule}/objectifs/${idObjectif}`, {
            headers: {
                Authorization: `Bearer ${token}`,
                Accept: 'application/json',
            },
        })
            .then((res) => {
                if (res.data.status === 200) {
                    setObjectifInput(res.data.objectif.objectif);
                } else {
                    toast.error("Objectif introuvable");
                }
            })
            .catch((err) => {
                console.error(err);
            });

    }, [idModule, idObjectif, token]);

    const handleChangeObjectif = (e) => {
        setObjectifInput(e.target.value);
    }
    // modification 
    const handleUpdateObjectif = async (e) => { 
        e.preventDefault();
        setLoading(true);

        axios.put(`https://catalogue.mg.formafusion.io/api/cfp/modules/${idModule}/objectifs/${idObjectif}`, {
            module_objectif: objectifInput,
        }, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            }
        })
            .then((res) => {
                if (res.data.status === 200) {

                    onObjectifUpdated(res.data.objectif);
                    setTimeout(() => {
                        toast.success(res.data.message)
                        closeModalObjectif();
                    }, 2000)
                } else {
                    toast.error(res.data.message)
                }
            })
            .catch((err) => {
                console.log(err)
            })
            .finally(() => {
                setLoading(false);
            })
    }

    if (!showModalUpdateObjectif) return null;
    console.log("Loading:", loading);

    return (
        <>
            <ToastContainer
                position="top-right"
                autoClose={3000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
            />
            <div className="fixed inset-0 bg-black bg-opacity-40 backdrop-blur-sm z-50 flex items-center justify-center">
                <div className="bg-white shadow-2xl rounded-2xl w-11/12 md:w-3/4 lg:w-1/2 max-h-[90vh] overflow-hidden" data-aos="fade-down" data-aos-delay="300">

                    {/* Header */}
                    <div className="flex items-center justify-between px-5 py-3 bg-[#5B345B] border-b">
                        <p className="text-lg font-bold text-white text-center">Modifier votre Objectifs</p>
                        <button onClick={closeModalObjectif} className="p-2 hover:bg-slate-500 rounded-full transition">
                            <RxCross2 size={25} className="text-red-600 font-bold" />
                        </button>
                    </div>

                    {/* Formulaire */}
                    <form className="p-5 space-y-4 overflow-y-auto max-h-[80vh] custom-scroll" onSubmit={handleUpdateObjectif} >

                        <div>
                            <label className="block text-sm text-gray-600 mb-1">Objectif</label>
                            <input
                                type="text"
                                name="title"
                                value={objectifInput}
                                onChange={handleChangeObjectif}
                                className="w-full p-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-200"
                            />
                        </div>

                        {/* Action */}
                        <div className="flex justify-end gap-3 pt-4">
                            <button
                                type="submit"
                                className="px-4 py-2 bg-purple-700 text-white rounded-md hover:bg-purple-800 text-sm flex items-center gap-2"
                                disabled={loading}
                            >
                                {loading ? (
                                    <>
                                        <svg className="animate-spin h-4 w-4 text-white" viewBox="0 0 24 24">
                                            <circle className="opacity-25" cx="12" cy="12" r="10" stroke="white" strokeWidth="4" fill="none" />
                                            <path className="opacity-75" fill="white" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z" />
                                        </svg>
                                        <span>Chargement...</span>
                                    </>
                                ) : (
                                    'Modifier'
                                )}
                            </button>

                        </div>

                    </form>
                </div>
            </div>
        </>
    )
}